import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getResponsiveSize } from '../../utils/responsive';
import globalStyles from '../../global';

const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

const YearComponent = ({ year, title }) => {
  return (
    <Box sx={styles.box1}>
      <Box sx={styles.text1}>{year}</Box>
      <Box sx={styles.text2}>{title}</Box>
    </Box>
  );
};

const FranchiseTimeline = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#F2F3F0",
        py: getResponsiveSize(4),
        mt: 8,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          width: "100%",
          maxWidth: "1200px",
          position: "relative",
          mx: "auto",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            p: getResponsiveSize(2),
            fontSize: { md: "45px", sm: "30px", xs: "26px" },
            fontFamily: globalStyles.fonts.primaryUAE,
            fontWeight: 400,
            textTransform: "uppercase",
            textAlign: "left",
          }}
        >
          THE UCLEAN JOURNEY TO <br />
          <span>GLOBAL EXCELLENCE</span>
        </Typography>

        <Typography
          sx={{
            p: getResponsiveSize(2),
            fontSize: { sm: "18px", xs: "14px" },
            fontFamily: globalStyles.fonts.primary,
            color: "#666666",
            fontWeight: 400,
            mt: "-2%",
          }}
        >
          {t("franchiseTimeline.subTitle")}
        </Typography>

        <Box sx={[styles.box2, { marginLeft: { xs: "12%", md: "14%" } }]}>
          <YearComponent year={2017} title={t("franchiseTimeline.year2017")} />
          <YearComponent year={2021} title={t("franchiseTimeline.year2021.two")} />
          <YearComponent year={2022} title={t("franchiseTimeline.year2022")} />
          <YearComponent year={2025} title={t("franchiseTimeline.year2025")} />
        </Box>

        <Box
          sx={{
            width: "100%",
            display: {
              xs: "none",
              sm: "none",
              md: "flex",
            },
            justifyContent: "center",
            my: 3,
            ml: 2,
          }}
        >
          <img
            alt="timeline"
            src={`${imageBaseUrl}timeline.png`}
            style={{
              width: "90%",
              height: "auto",
              maxWidth: "100%",
            }}
          />
        </Box>

        <Box sx={styles.box2}>
          <YearComponent year={2016} title={t("franchiseTimeline.year2016")} />
          <YearComponent year={2019} title={t("franchiseTimeline.year2019")} />
          <YearComponent year={2021} title={t("franchiseTimeline.year2021.one")} />
          <YearComponent year={2024} title={t("franchiseTimeline.year2024")} />
        </Box>
      </Box>
    </Box>
  );
};

const styles = {
  text1: {
    fontSize: {
      xs: getResponsiveSize(20),
      sm: getResponsiveSize(24),
      md: getResponsiveSize(40),
      lg: getResponsiveSize(50),
    },
    fontFamily: ' "Poppins", serif ',
    fontWeight: 700,
    color: globalStyles.colors.light_gray1,
  },
  text2: {
    fontSize: {
      xs: getResponsiveSize(18 * 0.7),
      sm: getResponsiveSize(18 * 0.8),
      md: getResponsiveSize(18),
      lg: getResponsiveSize(18),
    },
    fontFamily: ' "Poppins", serif ',
    fontWeight: 500,
    color: globalStyles.colors.light_gray2,
  },
  box1: {
    width: {
      xs: "100%",
      sm: getResponsiveSize(200),
      md: getResponsiveSize(264),
    },
    padding: getResponsiveSize(1),
    textAlign: { xs: "center", md: "left" },
  },
  box2: {
    width: "80%",
    display: "flex",
    flexDirection: {
      xs: "column", // stack on mobile
      md: "row", // row on desktop
    },
    alignItems: "center",
    justifyContent: {
      xs: "center",
      md: "space-evenly",
    },
    gap: {
      xs: 2,
      md: 0,
    },
    mx: "auto",
  },
};
export default FranchiseTimeline;
